import { FunctionComponent } from "react";
import { useState } from 'react'
import Button from '../../../components/Button';
import { Information } from 'react-huge-icons/solid';
import { useTranslation } from "react-i18next";
import { ActiveWorkout } from "src/graphql";
import ActiveStrengthExercise from "./active-strength-exercise";
import ActiveCardioExercise from "./active-cardio-exercise";

interface ActiveWorkoutSectionProps {
    activeWorkout: ActiveWorkout;
    workoutExerciseId: string;
}


const ActiveWorkoutSection: FunctionComponent<ActiveWorkoutSectionProps> = ({ activeWorkout, workoutExerciseId }) => {
    const [watchVideoCollapsed, setWatchVideoCollapsed] = useState(true);
    const [displaySetsCollapsed, setDisplaySetsCollapsed] = useState(true);
    const workoutExercise = (activeWorkout.exercises || []).find((a) => a?.id === workoutExerciseId)!;

    const toggleWatchVideo = () => {
        setWatchVideoCollapsed(!watchVideoCollapsed);
        setDisplaySetsCollapsed(true)
    };

    const toggleDisplaySets = () => {
        setDisplaySetsCollapsed(!displaySetsCollapsed);
        setWatchVideoCollapsed(true)

    };

    const { t } = useTranslation();

    if (!workoutExercise) {
        return <div></div>
    }


    return (
        <section>
            <article className=' relative'>
                <div>
                    <div className="flex items-center justify-between">
                        <h1 className='lime'>{activeWorkout.name}</h1>
                        <div className='flex items-center gap-2'>
                            <a href="#exercises" className="text-blue">
                                רשימת תרגילים
                            </a>
                        </div>
                    </div>

                    <div className="flex items-center -mt-5 justify-between">
                        <h2 className='lime font-bold text-lg underline'>{workoutExercise?.name}</h2>
                        <div className='flex items-center gap-2'>
                            <Button onClick={toggleWatchVideo} sm link>
                                {t("watch_video")}
                            </Button>
                            <button onClick={toggleDisplaySets}>
                                <Information className='h-5 w-5 text-blue' />
                            </button>
                        </div>
                    </div>
                </div>

                {Boolean(workoutExercise?.notes) && <div className="flex gap-2 ">
                    <div>הערות: </div>
                    <pre className="text-wrap bg-gray-100 p-2">
                        {workoutExercise?.notes}
                    </pre>
                </div>}

                <article>
                    <div className='space-y-6'>
                        <div className='relative pb-6' hidden={!watchVideoCollapsed}>
                            <video src={workoutExercise.video_url || ""} controls className='w-full max-sm:w-full' />
                        </div>
                    </div>
                </article>


                <div className='font-Poppins'>
                    <div className='flex text-base flex-col gap-2'>
                        <div className='flex flex-row gap-2'>
                            {workoutExercise && workoutExercise.__typename === "ActiveStrengthExercise" && (<>
                                <p className='light'>
                                    {t("Total Sets")}:
                                </p>
                                <span>
                                    {workoutExercise?.sets?.length}
                                </span>
                            </>)}
                        </div>
                        <div className="space-y-4">
                            {workoutExercise.__typename === "ActiveCardioExercise" ? workoutExercise.intervals?.map((set, idx) => {
                                return <ActiveCardioExercise key={set?.id} interval={set!} idx={idx} workoutExerciseId={workoutExerciseId} />
                            }) : workoutExercise.__typename === "ActiveStrengthExercise" && workoutExercise.sets?.map((set, idx) => {
                                return <ActiveStrengthExercise key={set?.id} set={set!} idx={idx} workoutExerciseId={workoutExerciseId} />;
                            })}
                        </div>
                    </div>
                </div>
            </article>
        </section>
    );
}

export default ActiveWorkoutSection;